/**
 * Must match sector-workflow seed `_statics.js` / backend `staticsUids.categories.commercial`.
 */
export const COMMERCIAL_CATEGORY_UID = "8d948ed5-6be9-4f7f-a7aa-02deb710389b";

/** Seed UIDs for "Tidy up" and "Pets" — not allowed on commercial scopes. */
export const RESIDENTIAL_ONLY_SPECIAL_REQUEST_UIDS = new Set<string>([
  "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d",
  "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e",
]);

export function isCommercialCategory(category: { uid?: string; name?: string } | null | undefined): boolean {
  if (!category) return false;
  if (category.uid === COMMERCIAL_CATEGORY_UID) return true;
  return String(category.name || "").toLowerCase() === "commercial";
}

export function isResidentialOnlySpecialRequest(req: { uid?: string; name?: string } | null | undefined): boolean {
  if (!req) return false;
  if (req.uid && RESIDENTIAL_ONLY_SPECIAL_REQUEST_UIDS.has(String(req.uid))) return true;
  const n = String(req.name || "")
    .trim()
    .toLowerCase();
  return n === "tidy up" || n === "pets";
}
